import update from 'react-addons-update';
import { i18n } from 'core/i18n';
import {
	HOME_SEARCH_BOOKINGS_SUCCESS,
	HOME_CLEAN_BOOKINGS,
	HOME_GET_BOOKING_DATA_SUCCESS,
	HOME_CLEAN_BOOKING_DATA,
	HOME_TAX_REFUND_DIALOG,
	HOME_OPEN_REMOVE_UNPAID_BOOKING_DIALOG,
	HOME_REMOVE_UNPAID_BOOKING_DIALOG
} from './action.js';

const initState = {
	action: null,
	bookingRows: [],
	removedPnrs: [],
	bookingData: null,
	translationData: null,
};

export default function homeReducer(state = initState, action) {
	switch (action.type) {
		case HOME_SEARCH_BOOKINGS_SUCCESS:
			let bookingRows = action.data.filter(x => {
				if (x.bookingReference) {
					if (state.removedPnrs.indexOf(x.bookingReference) !== -1) {
						return false;
					}
				}
				return true;
			});
			bookingRows.map((item) => {
				if (item === null) {
					bookingRows = [];
					return true;
				};
				if (item.flightNumbers && item.flightNumbers.length !== 0) {
					let flightNumberString = '';
					item.flightNumbers.forEach((flightNumbersItem, flightNumbersIndex) => {
						if (flightNumbersIndex === 0) {
							flightNumberString += flightNumbersItem;
						} else {
							flightNumberString += ` - ${flightNumbersItem}`;
						}
					});
					item.pnr = item.bookingReference;
					item.bookingReference = `${item.bookingReference} (${flightNumberString})`;

				}
				item.event = {
					bookingReference: item.bookingReference ? item.bookingReference : '',
					editable: !item.allFlown && item.bookingStatus !== 'holdCanceled',
					printable: item.bookingStatus === 'confirmed'
				}
				return true;
			});
			switch (action.tab) {
				case 1:
					bookingRows = bookingRows.filter(function (item) {
						return item.bookingStatus && item.bookingStatus === 'confirmed';
					});
					break;
				case 2:
					console.log(action.tab)
					break;
				case 3:
					console.log(action.tab)
					break;
				default:
					break;
			}
			if (bookingRows.length === 0) {
				bookingRows = [
					{ bookingReference: i18n('no_booking_reference') }
				];
			}
			return update(state, {
				action: { $set: action.type },
				bookingRows: { $set: bookingRows }
			});
		case HOME_CLEAN_BOOKINGS:
			return update(state, {
				action: { $set: action.type },
				bookingRows: { $set: [] }
			});
		case HOME_GET_BOOKING_DATA_SUCCESS:
			return update(state, {
				action: { $set: action.type },
				bookingData: { $set: action.data }
			});
		case HOME_CLEAN_BOOKING_DATA:
			return update(state, {
				action: { $set: action.type },
				bookingData: { $set: null }
			});
		case HOME_TAX_REFUND_DIALOG:
			return update(state, {
				action: { $set: action.type },
				openTaxRefundDialog: { $set: true }
			});
		case HOME_OPEN_REMOVE_UNPAID_BOOKING_DIALOG:
			return update(state, {
				action: { $set: action.type },
				removeUnpaidBookingDialog: { $set: true }
			});
		case HOME_REMOVE_UNPAID_BOOKING_DIALOG:
			let ns = {
				action: { $set: action.type },
				removeUnpaidBookingDialog: { $set: false },
			};
			if (action.pnr) {
				ns["removedPnrs"] = { $push: [action.pnr] }
			}
			return update(state, ns);
		default:
			return state;
	}
}